import styled from 'styled-components'

export const Container = styled.header`
  width: 100vw;
  box-shadow: 0px 1px 18px 0px #00000026;
  margin: 0;
  background: ${({ theme }) => `rgb(${theme.background.high})`};

  .header {
    background: ${({ theme }) => `rgb(${theme.background.header})`};
  }

  hr {
    margin: 0;
    border: none;
    border-top: 1px solid ${({ theme }) => `rgb(${theme.component.accent})`};
  }
`

export const ButtonsWrapper = styled.div`
  position: relative;

  width: 100%;

  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: 8px 14px;

  .logoDirecao {
    width: 7.375rem;
    height: auto;
  }

  @media only screen and (min-width: 400px) {
    padding: 12px 20px;

    .logoDirecao {
      width: 8rem;

      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }

    .headerOptions {
      button {
        width: 32px;
        height: 32px;

        img,
        svg {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
`
